// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
// Sibling imports
const contentAddModalActions = require('./actions')
const ContentAddModal = require('./component-dumb')
const selectors = require('./selectors')

function mapStateToProps() {
  const promoSelector = selectors.createPromoSelector()
  return function (state) {
    if (!selectors.isVisible(state)) {
      return { isVisible: false }
    }
    return {
      // Flags
      isArticleFailed: selectors.isArticleFailed(state),
      isArticleLoading: selectors.isArticleLoading(state),
      isCollectionsModalVisible: selectors.isCollectionsModalVisible(state),
      isSubmitDisabled: !selectors.isArticleLoaded(state),
      isSubmitPending: selectors.isSubmitPending(state),
      isUrlInvalid: selectors.isUrlInvalid(state),
      isVisible: true,
      // Values
      article: selectors.article(state),
      errorMessage: selectors.errorMessage(state),
      postHref: selectors.postHref(state),
      promo: promoSelector(state),
      url: selectors.url(state)
    }
  }
}

const mapDispatchToProps = {
  fetchArticle: contentAddModalActions.fetchArticle,
  onDismiss: contentAddModalActions.hide,
  onRetryClick: contentAddModalActions.retryFetch,
  onUrlSubmit: contentAddModalActions.submit,
  onUrlTextChange: contentAddModalActions.setUrlText
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    withImmutableToJS(
      ContentAddModal
    )
  )
)
